import script from "./Furniture3DViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./Furniture3DViewer.vue?vue&type=script&setup=true&lang=js"

import "./Furniture3DViewer.vue?vue&type=style&index=0&id=afe5c8b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe5c8b0"]])

export default __exports__